import React, {
  createContext,
  PropsWithChildren,
  useCallback,
  useState,
} from 'react';

export interface UrlDocumentContextType {
  documentHtml?: string | undefined;
  documentUrl?: string | undefined;
  setDocumentHtml?: (documentHtml: string) => void;
  setDocumentUrl?: (documentUrl: string) => void;
}

const UrlDocumentContext = createContext<UrlDocumentContextType>({});

export const UrlDocumentContextProvider = ({ children }: PropsWithChildren) => {
  const [documentHtml, setDocumentHtmlImp] = useState<string | undefined>(
    undefined,
  );
  const [documentUrl, setDocumentUrlImp] = useState<string | undefined>(
    undefined,
  );

  const setDocumentUrl = useCallback(
    (documentUrl: string) => {
      setDocumentUrlImp(documentUrl);
      setDocumentHtmlImp(undefined);
    },
    [setDocumentUrlImp, setDocumentHtmlImp],
  );

  const setDocumentHtml = useCallback(
    (documentHtml: string) => {
      setDocumentHtmlImp(documentHtml);
      setDocumentUrlImp(undefined);
    },
    [setDocumentHtmlImp, setDocumentUrlImp],
  );

  return (
    <UrlDocumentContext.Provider
      value={{
        documentHtml,
        documentUrl,
        setDocumentHtml,
        setDocumentUrl,
      }}
    >
      {children}
    </UrlDocumentContext.Provider>
  );
};

export default UrlDocumentContext;
